// Constants
const CHAT_DELAY_MS = 30000; // Half a minute delay before opening the chat
const AGENT_CHECK_ENDPOINT =
  "/integrations/chat-has-agents-during-office-hours"; // Endpoint to check agent availability
const STORAGE_KEY = "genesisPopupExpires";

// Chat Expiry Utilities
const setChatExpiry = () => {
  const expiryTime = new Date();
  expiryTime.setHours(expiryTime.getHours() + 24);
  localStorage.setItem(STORAGE_KEY, expiryTime.toISOString());
};

const isChatExpired = () => {
  const expiry = localStorage.getItem(STORAGE_KEY);
  if (!expiry) return true;

  const isExpired = new Date(expiry) < new Date();
  if (isExpired) localStorage.removeItem(STORAGE_KEY);
  return isExpired;
};

// Chat Operations
const openChat = () =>
  new Promise((resolve, reject) => {
    try {
      /* eslint-disable */
      Genesys("subscribe", "Messenger.ready", () => {
        Genesys(
          /* eslint-enable */
          // stop eslint from complaining about Genesys being undefined
          "command",
          "Messenger.open",
          {},
          () => {
            console.log("Messenger opened successfully");
            resolve();
          },
          (error) => {
            console.error("Failed to open messenger:", error);
            reject(error);
          }
        );
      });
    } catch (error) {
      console.error("Error in openChat:", error);
      reject(error);
    }
  });

const setTimerForChat = () => {
  return setTimeout(() => {
    openChat().catch(console.error);
  }, CHAT_DELAY_MS);
};

// Initialization
const setupMessengerEvents = () => {
  // eslint-disable-next-line
  Genesys("subscribe", "Messenger.closed", () => {
    console.log("Messenger closed");
    setChatExpiry();
  });
};

const initChatSequence = async () => {
  try {
    const response = await fetch(AGENT_CHECK_ENDPOINT);
    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);

    const data = await response.json();
    console.log("Agent availability data:", data);

    if (data.success) return setTimerForChat();
  } catch (error) {
    console.error("Error initializing chat sequence:", error);
    throw error;
  }
};

// Observe only for 20 seconds and then disconnect

// Main Observer
const observer = new MutationObserver(() => {
  if (typeof Genesys === "undefined") return;
  observer.disconnect();

  if (isChatExpired()) {
    console.log("Initializing chat sequence...");
    setupMessengerEvents();
    initChatSequence().catch(console.error);
  } else {
    console.log("Chat popup is still valid, not initializing.");
  }
});

// Start observing
observer.observe(document, {
  childList: true,
  subtree: true,
});
